import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'aw-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.less']
})
export class SpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
